import type { ShellBootstrap } from '../../shared/contract/bootstrap.js';
import { parseShellBootstrap, SHELL_BOOTSTRAP_ID } from '../../shared/shell-bootstrap.js';

let taken = false;

/**
 * Take the signed-in startup data the shell page embedded (HS2-TMF3KZ): once per
 * page, and the element is removed so the block cannot be read twice. Null when
 * the page carries none (signed out), it is malformed or stale, or it was already
 * taken — the caller then fetches as before.
 */
export function takeShellBootstrap(): ShellBootstrap | null {
  if (taken || typeof document === 'undefined') return null;
  taken = true;
  const element = document.getElementById(SHELL_BOOTSTRAP_ID);
  if (element === null) return null;
  element.remove();
  return parseShellBootstrap(element.textContent);
}
